/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import BaseURL from "../../BaseURL/BaseURL";
import axios from "axios";
import Swal from "sweetalert2";
import { GoogleMap, useJsApiLoader, MarkerF } from "@react-google-maps/api";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { TailSpin } from "react-loader-spinner";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const center = {
  lat: 24.8607343,
  lng: 67.0011364,
};

const Detail = () => {
  const search = useLocation().search;
  const id = new URLSearchParams(search).get("id");
  const user_id = localStorage.getItem("id");
  const token = localStorage.getItem("token");
  console.log(id, "id==== ");

  const [Loader, setLoader] = useState(false);
  const [api, setApi] = useState([]);
  const [Position, setPosition] = useState({
    lat: 0,
    lng: 0,
  });
  const [modal, setModal] = useState(false);
  const [Review, setReview] = useState("");
  const [Comment, setComment] = useState("");
  const [Reviewapi, setReviewapi] = useState([]);

  const alldoctor = () => {
    // setLoader(true);
    try {
      var config = {
        method: "Get",
        url: `${BaseURL.baseurl}/api/doctors?id=${id}`,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setApi(response.data.data[0]);
          setPosition({
            lat: parseFloat(response.data.data[0]?.latitude),
            lng: parseFloat(response.data.data[0]?.longitude),
          });

          // dispatch(doctorapi(response.data.data))
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  useEffect(() => {
    alldoctor();
  }, []);

  const review = () => {
    setLoader(true);
    try {
      const data = new FormData();
      data.append("user_id", user_id);
      data.append("doctor_id", id);
      data.append("star", Review);
      data.append("review", Comment);

      var config = {
        method: "POST",
        url: `${BaseURL.baseurl}/api/user/reviews`,
        data: data,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          if (response?.data?.status === true) {
            setLoader(false);
            setModal(false);
            Swal.fire({
              title: "Something Went Wrong",
              text: response?.data?.response
                ? response?.data?.response
                : "Review Submit",

              icon: "success",
              dangerMode: true,
            });
          } else {
            setLoader(false);
            console.log(response, "api");
          }
        })
        .catch((errors) => {
          console.log(errors, "api");
          setLoader(false);
          setModal(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.response?.data?.message
              ? errors.response?.data?.message
              : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      console.log(errors, "api");
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  const getreview = () => {
    // setLoader(true);
    try {
      var config = {
        method: "Get",
        url: `${BaseURL.baseurl}/api/reviews`,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      axios(config)
        .then(function (response) {
          console.log(response, "reviews");
          setReviewapi(response?.data?.data);
          // dispatch(doctorapi(response.data.data))
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  useEffect(() => {
    getreview();
  }, []);

  // console.log(Review,"Review")
  //google map work

  const { isLoaded } = useJsApiLoader({
    // id: "google-map-script",
    googleMapsApiKey: "AIzaSyDF1PVJNBK1GGAQmfCpc-yepBkGUdkfgVQ",
    libraries: ["places"],
  });

  const handleClose = () => setModal(false);
  const handleShow = () => {
    if (token) {
      setModal(true);
    } else {
      navigate("/login");
    }
  };
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div class="container margin_60">
        <div class="row">
          <div class="col-xl-12 col-lg-12">
            <nav id="secondary_nav" className="bg-theme">
              <div class="container">
                <ul class="clearfix">
                  <li>
                    <a href="#section_1" class="active">
                      General info
                    </a>
                  </li>
                  <li>
                    <a href="#section_2">Reviews</a>
                  </li>
                  <li>
                    <a href="#sidebar">Booking</a>
                  </li>
                </ul>
              </div>
            </nav>
            <div id="section_1">
              <div class="box_general_3">
                <div class="profile">
                  <div class="row">
                    <div class="col-lg-5 col-md-4">
                      <figure>
                        <img
                          src={api?.image}
                          alt=""
                          class="img-fluid"
                        />
                      </figure>
                    </div>
                    <div class="col-lg-7 col-md-8">
                      <small>{api?.type}</small>
                      <h1>
                        {api?.fname} {api?.mname} {api?.lname}
                      </h1>
                      {/* <span class="rating">
                        <i class="icon_star voted"></i>
                        <i class="icon_star voted"></i>
                        <i class="icon_star voted"></i>
                        <i class="icon_star voted"></i>
                        <i class="icon_star"></i>
                        <small>(145)</small>
                        <a
                          href="badges.html"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Badge Level"
                          class="badge_list_1"
                        >
                          <img
                            src="img/badges/badge_1.svg"
                            width="15"
                            height="15"
                            alt=""
                          />
                        </a>
                      </span> */}
                      {/* <ul class="statistic">
                        <li>854 Views</li>
                        <li>124 Patients</li>
                      </ul> */}
                      <ul class="contacts">
                        <li>
                          <h6>Address</h6>
                          <small>
                            {api?.street_address} | {api?.city} | {api?.state} |{" "}
                            {api?.country}{" "}
                          </small>
                        </li>
                        <li>
                          <h6>Email</h6>
                          <small>{api?.email}</small>
                        </li>
                        {/* <li>
                          <h6>Phone</h6>{" "}
                          <a href="tel://000434323342">+00043 4323342</a> -{" "}
                          <a href="tel://000434323342">+00043 4323342</a>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
                <hr />

                {/* <!-- /profile --> */}

                <div class="wrapper_indent">
                  <div class="row">
                    <div className="col-md-12">
                      <label className="h4 mb-2">Bio</label>
                      <p>{api?.description}</p>
                    </div>
                    {/* <!-- /row--> */}
                  </div>
                </div>
                <hr />

                {/* <!-- /profile --> */}

                <div class="wrapper_indent">
                  <div class="row">
                    <div class="col-lg-6">
                      <ul class="bullets">
                        <li>
                          <b>Hypnosis Utilization:</b>{" "}
                          {api?.hypnosis_utilization}
                        </li>
                        <li>
                          <b>Organization:</b> {api?.organization}
                        </li>
                        <li>
                          <b>Training:</b> {api?.training}
                        </li>
                        <li>
                          <b>Practice Years:</b> {api?.practice_years}
                        </li>
                      </ul>
                    </div>
                    <div class="col-lg-6">
                      <ul class="bullets">
                        <li>
                          <b>Education:</b> {api?.education}
                        </li>
                        <li>
                          <b>Certificate:</b> {api?.certificate}
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <!-- /row--> */}
                </div>
                {/* <!--  /wrapper_indent --> */}

                {/* <!-- /section_1 --> */}
              </div>
            </div>
            {/* <!-- /box_general --> */}

            <div className="" style={{}}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={
                  Position.lat !== 0 && Position.lng !== 0 ? Position : center
                }
                zoom={15}
                options={{
                  zoomControl: false,
                  streetViewControl: false,
                  mapTypeControl: false,
                  fullscreenControl: false,
                }}
              >
                <MarkerF
                  position={
                    Position.lat !== 0 && Position.lng !== 0 ? Position : center
                  }
                />
              </GoogleMap>
            </div>

            <div id="section_2 " className="mt-5">
              <div class="box_general_3">
                <div class="reviews-container">
                  {/* <div class="row">
                    <div class="col-lg-3 ">
                      <div id="review_summary" className="bg-theme">
                        <strong>{api?.averageRating}</strong><br/>
                        <small>Total Average Rating</small>
                      </div>
                    </div>
                    <div class="col-lg-9">
                      <div class="row">
                        <div class="col-lg-10 col-9">
                          <div class="progress">
                            <div
                              class="progress-bar bg"
                              role="progressbar"
                              style={{ width: "90%" }}
                              aria-valuenow="90"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                        <div class="col-lg-2 col-3">
                          <small>
                            <strong>5 stars</strong>
                          </small>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-10 col-9">
                          <div class="progress">
                            <div
                              class="progress-bar bg"
                              role="progressbar"
                              style={{ width: "95%" }}
                              aria-valuenow="95"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                        <div class="col-lg-2 col-3">
                          <small>
                            <strong>4 stars</strong>
                          </small>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-10 col-9">
                          <div class="progress">
                            <div
                              class="progress-bar bg"
                              role="progressbar"
                              style={{ width: "60%" }}
                              aria-valuenow="60"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                        <div class="col-lg-2 col-3">
                          <small>
                            <strong>3 stars</strong>
                          </small>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-10 col-9">
                          <div class="progress">
                            <div
                              class="progress-bar bg"
                              role="progressbar"
                              style={{ width: "20%" }}
                              aria-valuenow="20"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                        <div class="col-lg-2 col-3">
                          <small>
                            <strong>2 stars</strong>
                          </small>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-10 col-9">
                          <div class="progress">
                            <div
                              class="progress-bar bg"
                              role="progressbar"
                              style={{ width: 0 }}
                              aria-valuenow="0"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                        <div class="col-lg-2 col-3">
                          <small>
                            <strong>1 stars</strong>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <!-- /row --> */}
                  {Reviewapi?.map((e) => (
                    <>
                      <div class="review-box clearfix">
                        <figure class="rev-thumb">
                          <img src={e?.user?.image ? e?.user?.image : `img/avatar1.jpg`} alt="" />
                        </figure>
                        <div class="rev-content">
                          <div class="rating">
                            {e?.star == 1 ? (
                              <>
                                <i class="icon_star voted"></i>
                              </>
                            ) : e?.star == 2 ? (
                              <>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                              </>
                            ) : e?.star == 3 ? (
                              <>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                              </>
                            ) : e?.star == 4 ? (
                              <>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                              </>
                            ) : e?.star == 5 ? (
                              <>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                                <i class="icon_star voted"></i>
                              </>
                            ) : null}
                          </div>
                          <div class="rev-info">{e?.user?.fname} {e?.user?.lname}</div>
                          <div class="rev-text">
                            <p>{e?.review}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                  {/* <!-- End review-box --> */}
                </div>
                {/* <!-- End review-container --> */}
                <hr />
                <div class="text-end">
                  <button class="btn-theme" onClick={handleShow}>
                    Add Reviews
                  </button>
                </div>
              </div>
            </div>
            {/* <!-- /section_2 --> */}
          </div>
          {/* <!-- /asdide --> */}
        </div>
        {/* <!-- /row --> */}
      </div>
      <Footer />

      <Modal
        show={modal}
        size="lg"
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center"
          >
            Leave A Review
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="review">
            <fieldset class="supaview__rating">
              <input
                type="radio"
                id="star5"
                name="rate"
                value="5"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star5"></label>
              <input
                type="radio"
                id="star4"
                name="rate"
                value="4"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star4"></label>
              <input
                type="radio"
                id="star3"
                name="rate"
                value="3"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star3"></label>
              <input
                type="radio"
                id="star2"
                name="rate"
                value="2"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star2"></label>
              <input
                type="radio"
                id="star1"
                name="rate"
                value="1"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star1"></label>
            </fieldset>
            <div class="supaview__copy">
              <textarea
                name="message"
                placeholder="Message"
                rows="5"
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button class=" btn-theme" onClick={review}>
            {Loader === true ? (
              <TailSpin
                height="20"
                width="20"
                color="#4fa94d"
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              />
            ) : (
              "Submit review"
            )}
          </button>
          <Button onClick={handleClose} className="btn-theme">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Detail;
